import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { WHY_STATS } from "@/lib/site-data";

function Counter({ value, suffix, raw }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView || raw) return;
    let start = null;
    const dur = 1400;
    const step = (t) => {
      if (start === null) start = t;
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(value * eased);
      if (p < 1) requestAnimationFrame(step);
    };
    const id = requestAnimationFrame(step);
    return () => cancelAnimationFrame(id);
  }, [inView, value, raw]);

  const isFloat = !Number.isInteger(value);
  const shown = raw ? raw : `${isFloat ? display.toFixed(1) : Math.round(display).toLocaleString()}${suffix}`;
  return (
    <span ref={ref} className="font-display text-5xl font-extrabold text-[#1F1F1F] sm:text-6xl">
      {shown}
    </span>
  );
}

export default function WhyChooseUs() {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
            <span className="h-px w-8 bg-[#E31B23]" /> Why choose us
          </div>
          <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-tight text-[#1F1F1F] sm:text-5xl">
            Numbers our customers trust.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-5">
          {WHY_STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.06}>
              <div data-testid={`why-stat-${i}`} className="border-l-2 border-[#F4B400] pl-5">
                <Counter value={s.value} suffix={s.suffix} raw={s.raw} />
                <div className="mt-2 text-sm font-medium text-[#4b5563]">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
